export default "__VITE_ASSET__da7eb386__"